// extracted by mini-css-extract-plugin
module.exports = {"icon":"ResourceTypeIcon_icon__ZoIyn"};